import {forwardRef} from "react";
import {motion} from "motion/react";
import {Button} from "./Button";
import {TMotionButtonProps} from "./types";

const MotionButtonCreate = motion.create(Button, {forwardMotionProps: true})

export const MotionButton = forwardRef((props: TMotionButtonProps, forwardRef) => {

    return (
        <MotionButtonCreate {...props} ref={forwardRef}/>
    )
})